import { Crosshair, Lightbulb } from 'lucide-react';
import type { Components } from 'react-markdown';

import { CodeBlock } from './code-block';

export const reportComponents: Components = {
	h2: ({ children }) => (
		<h2 className="mb-2 mt-6 flex items-center gap-3 font-semibold leading-relaxed text-gray-2 dark:text-white">
			{children === 'Совет' && (
				<Lightbulb
					aria-hidden="true"
					size={22}
					className="shrink-0 text-accent"
				/>
			)}
			{children === 'Эталонный ответ' && (
				<Crosshair
					aria-hidden="true"
					size={20}
					className="shrink-0 text-gray-3"
				/>
			)}
			{children}
		</h2>
	),
	code: (props) => <CodeBlock {...props} showToolbar />,
};
